module.exports = __webpack_public_path__ + "static/media/img_03_2x_en.6183416d.png";